import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { FIELD_OPS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SurveySubmissionDetailPage } from '@/features/surveys/pages/SurveySubmissionDetailPage';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/feedback/surveys/$surveyId/submissions/$submissionId')(
  {
    beforeLoad: () => requirePermission(FIELD_OPS_PERMISSIONS.SURVEY_VIEW),
    parseParams: (rawParams) => {
      const params = parsePositiveIdParams(rawParams);
      if (params === null) throw notFound();
      return params;
    },
    component: function SurveySubmissionDetailRoute() {
      const { surveyId, submissionId } = Route.useParams();
      return (
        <ErrorBoundary moduleName="Submission Details">
          <Suspense fallback={<PageLoader />}>
            <SurveySubmissionDetailPage surveyId={surveyId} submissionId={submissionId} />
          </Suspense>
        </ErrorBoundary>
      );
    },
  },
);
